// extracted by mini-css-extract-plugin
export default {"wrapper":"notifications_wrapper__2Yg7z","wrapperRead":"notifications_wrapperRead__n8h1I","title":"notifications_title__Q+Cm3"};